import type { PathwayOptionSet } from '../configuration/shared';
import { useProgramContentOverride } from '../contexts/DrugProgramProvider';
import { useFillPrescription } from '../contexts/fill/use-fill-prescription';

import { useDrugKey } from './use-drug-key';

export const useMedicareBridgeEligibilityStepper =
    (): PathwayOptionSet | null => {
        const { medication } = useFillPrescription();
        const drugKey = useDrugKey(medication);
        const contentOverride = useProgramContentOverride();

        if (drugKey) {
            return (
                contentOverride.pathwayOptions?.[drugKey]
                    ?.medicareBridgeContent ?? null
            );
        }

        // Fallback: drugKey lookup failed (NDC not in drug program API response).
        // Scan all pathway options for one that has medicareBridgeContent configured.
        for (const opts of Object.values(
            contentOverride.pathwayOptions ?? {}
        )) {
            if (opts?.medicareBridgeContent) return opts.medicareBridgeContent;
        }

        return null;
    };
